class Logging extends Error {
  constructor(message = "") {
    super(message);
    console.log(this.message);
  }

  file(fileName) {
    this.fileName = fileName;
    return this;
  }

  error(errorObject) {
    this.errorObject = errorObject;
    return this;
  }

  method(fn) {
    switch (typeof fn) {
      case "function":
        this.methodName = fn.name;
        break;
      case "string":
        this.methodName = fn;
        break;
      default:
        throw this.fire("Unsupported method type passed into emission.");
    }
    return this;
  }

  phoneHome(msg = null) {
    // NOTE: I'm commenting this code out because pin point is not yet
    //       ready for production.
    // TODO: This needs to be fixed before the next release.
    // fetch("https://pinpoint.us-east-1.amazonaws.com/v1")
    //   .catch(() => console.warn("phoneHome failed."));
  }

  fire(msg = null) {
    this.phoneHome();

    return new Error(msg || this.message);
  }
}

const logging = msg => new Logging(msg);

const objToKVString = obj => {
  const output = [];

  for (const k in obj) {
    output.push(`${k}=${obj[k]}`);
  }

  return output.join(", ");
};

logging.objToKVString = objToKVString;

export { Logging, logging, objToKVString };
